// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__A+6HN","title":"style_title__ZuHeF","text":"style_text__8z5Lr","CTA":"style_CTA__CUuoK"};